import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Drawer, List, ListItem, ListItemText, Toolbar, Typography, Container, Hidden, SwipeableDrawer } from '@material-ui/core';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import RouteConstants from '../common/RouteConstants';
import {
    UserProfileProvider,
    UserProfileConsumer,

} from "../common/ProfileContext";
import { useState } from 'react';
import AppBar from '../sharedComponents/appBar/AppHeaderBar';
import UserActionMenu from '../sharedComponents/appBar/UserActionMenu';
import NotificationMenu from '../sharedComponents/Notifications/NotificationMenu';
import Navbar from '../sharedComponents/multiLevelTopNav/NavBar';
import NavDrawer from '../sharedComponents/multiLevelTopNav/NavDrawer';
import PublicActionMenu from '../sharedComponents/appBar/PublicActionMenu';



const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },

        // marginTop:
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
            marginBottom: 10,
            marginTop: 64
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: "#0c214c",
        marginTop: 48,
        zIndex: 0,
        color: '#ffffff',
        // '& .MuiListItem-button': {
        //      backgroundColor: '#1d428a',
        //     color: '#ffffff',
        //  },
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    title: {
        fontWeight: 600,
    }
}));

const CurriculumLayout = ({ history, children }) => {
    const theme = useTheme();
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const toggleDrawer = (value) => event => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(value);
    };

    const handleManageCurriculumBadges = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_BADGES,
            state: undefined,
        })
    }
    const handleManageCurriculumLevel = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_LEVELS,
            state: undefined,
        })
    }

    const handleManageResource = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_RESOURCE,
            state: undefined,
        })
    }

    const handleManageResourceType = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_RESOURCE_TYPE,
            state: undefined,
        })
    }

    const handleManageQuestionType = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_QUESTION_TYPE,
            state: undefined,
        })
    }

    const handleManageCurriculumData = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_DATA,
            state: undefined,
        })
    }

    const handleManageQuestionBank = () => {
        setOpen(false)
        return history.push({
            pathname: RouteConstants.MANAGE_CURRICULUM_QUESTIONS,
            state: undefined,
        })
    }

    const handleAssignCurriculum = () => {
            setOpen(false)
            return history.push({
                pathname: RouteConstants.MANAGE_LESSON_PLANS,
                state: undefined,
            })
        }


    return (
        <>
            <AppBar
                mainNav={<Navbar />}
                mobileNav={<NavDrawer />}
                notificationMenu={<NotificationMenu />}
                userActionMenu={<UserActionMenu />}
                 publicActionMenu={ <PublicActionMenu /> }
            />
            <div className={classes.root}>
                <CssBaseline />
                <nav className={classes.drawer} aria-label="side nav">
                    <Hidden xsDown>
                        <Drawer

                            variant="permanent"
                            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            <List>
                                <ListItem button onClick={handleManageCurriculumLevel} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_LEVELS ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Curriculum Levels' />
                                </ListItem>
                                <ListItem button onClick={handleManageCurriculumBadges} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_BADGES ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Curriculum Badges' />
                                </ListItem>
                                {/* <ListItem button onClick={handleManageResourceType} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_RESOURCE_TYPE ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Resource Type' />
                                </ListItem>
                                <ListItem button onClick={handleManageResource} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_RESOURCE ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Resource' />
                                </ListItem>
                                <ListItem button onClick={handleManageQuestionType} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_QUESTION_TYPE ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Question Type' />
                                </ListItem> */}
                                {/* <ListItem button onClick={handleManageCurriculumData} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_DATA ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Curriculums' />
                                </ListItem> */}
                                <ListItem button onClick={handleManageQuestionBank} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_CURRICULUM_QUESTIONS ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Question Bank' />
                                </ListItem>
                                <ListItem button onClick={handleAssignCurriculum} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_LESSON_PLANS ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Assign Curriculum' />
                                </ListItem>
                            </List>
                        </Drawer>
                    </Hidden>
                    <Hidden mdUp>
                        <SwipeableDrawer
                            open={open}
                            onClose={toggleDrawer(false)}
                            onOpen={toggleDrawer(true)}
                            variant="temporary"
                            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            {/* <List>
                                <ListItem button onClick={handleManageCommunicationCategory} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_COMMUNICATION_CATEGORY ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Communication Category' />
                                </ListItem>
                                <ListItem button onClick={handleManageEvaluationCategory} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_EVALUATION_CATEGORY ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Evaluation Category' />
                                </ListItem>
                                <ListItem button onClick={handleManageCompetencies} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_COMPETENCY ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Competencies' />
                                </ListItem>
                                <ListItem button onClick={handleManageQuizzes} style={{ backgroundColor: history.location.pathname === RouteConstants.MANAGE_QUIZ ? '#1d428a' : undefined }}>
                                    <ListItemText primary='Manage Quizzes' />
                                </ListItem>
                            </List> */}
                        </SwipeableDrawer>
                    </Hidden>
                </nav>
                {children}
            </div>
        </>
    )
}


export default CurriculumLayout;